import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLocationDot} from "@fortawesome/free-solid-svg-icons";
import PlacesAutocomplete from "react-places-autocomplete";

function PlacesAutoCompleteInput({data, setData, objKey, index}) {

    function handleArrayData(value, index, key) {
        setData(
            data.map((row, i) =>
                i === index ? {...row, [key]: value} : row
            )
        );
    }

    return (
        <PlacesAutocomplete
            value={(index!==undefined && index!==null)?data[index][objKey] : data[objKey]}
            onChange={
                (e) => {
                    if(index!==undefined && index!==null){
                        handleArrayData(e, index, objKey);
                    }
                    else{
                        setData(() => ({
                            ...data,
                            [objKey]: e,
                        }))
                    }

                }
            }
            onSelect={(address, placeId) => {
                if(index!==undefined && index!==null){
                    handleArrayData(address, index, objKey);
                }else{
                    setData(() => ({
                            ...data,
                            [objKey]: address,
                        }
                    ))
                }

            }}
        >
            {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                <div className="places-div">
                    <input
                        {...getInputProps({
                            placeholder: "Street, building, city, country",
                            className: "form-control places-input",
                        })}
                    />
                    <FontAwesomeIcon className="faLocation" icon={faLocationDot}/>
                    {/*<img src="/Images/pin.png"/>*/}

                    <div className="autocomplete-dropdown-container">
                        {loading && <div>Loading...</div>}
                        {suggestions.map((suggestion) => {
                            const className = suggestion.active
                                ? "suggestion-item--active"
                                : "suggestion-item";
                            const style = suggestion.active
                                ? {backgroundColor: "#fafafa", cursor: "pointer"}
                                : {backgroundColor: "#ffffff", cursor: "pointer"};
                            return (
                                <div
                                    {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                    })}
                                >
                                    <span>{suggestion.description}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </PlacesAutocomplete>
    );
}

export default PlacesAutoCompleteInput;